import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useInvitePatient = () => {
  const errors = useSelector(state => state.errors.patient_invitations);
  const isLoading = useSelector(state => state.loading.models.patientInvitations);
  const dispatch = useDispatch();

  const error = useMemo(() => {
    if (errors) {
      const { invite, connect } = errors;
      if (invite) return { invite };
      if (connect) return { connect };
    }
    return {};
  }, [errors]);

  return {
    invite: dispatch.patientInvitations.invite,
    connect: dispatch.patientInvitations.connect,
    isLoading,
    error,
  };
};

export default useInvitePatient;
